import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { PageHeader } from './PageHeader'
import { Leaf } from '../leaf/LeafDefs'
import { LEAF_RADIUS } from '../../styles/theme'
import { useI18n } from '@/core/i18n/useI18n'

/** Página "em breve" para as rotas de backoffice ainda não implementadas (Marco 1). */
export function PlaceholderPage({ title }: { title: string }) {
  const { t } = useI18n()
  return (
    <Box>
      <PageHeader title={title} eyebrow={t('components.placeholderPage.eyebrow')} />
      <Box
        sx={{
          border: '1px dashed',
          borderColor: 'divider',
          borderRadius: LEAF_RADIUS,
          bgcolor: 'background.paper',
          py: 10,
          px: 4,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box sx={{ width: 64, height: 32, color: 'secondary.main', opacity: 0.35 }}>
          <Leaf style={{ width: '100%', height: '100%' }} />
        </Box>
        <Typography variant="h5" sx={{ color: 'text.primary' }}>
          {t('components.placeholderPage.comingSoon')}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 380 }}>
          {t('components.placeholderPage.description')}
        </Typography>
      </Box>
    </Box>
  )
}
